export function formatLikes(value: number): string | number {
    if (value <= 999) {
        return value;
    } else if (value < 10 ** 6) {
        // under 1M format in Ks with one decimal place
        const valueInThousand = Math.round(Math.floor(value / 100)) / 10;
        return `${valueInThousand}K`;
    } else if (value < 10 ** 7) {
        //under 10M format with one decimal place
        const valueInMillions = Math.round(Math.floor(value / 100000)) / 10;
        return `${valueInMillions}M`;
    } else {
        //above 10M format with no decimal places
        const valueInMillions = Math.round(Math.floor(value / 1000000));
        return `${valueInMillions}M`;
    }
}
